<template>
  <div>
    <MessageAccueilVOLVIC50_SOIREE v-if="mainStore.module.base == 'VOLVIC50_SOIREE'"></MessageAccueilVOLVIC50_SOIREE>
    <MessageAccueilVOLVIC50 v-if="mainStore.module.base == 'VOLVIC50'"></MessageAccueilVOLVIC50>

    <div class="spo-card pa-2 rounded"
      v-if="mainStore.module.metadatas.message_accueil && mainStore.module.metadatas?.message_accueil != ''">
      <div class="text-h6 text-darkblue font-weight-bold">Informations</div>
      <div v-if="mainStore.module.base == 'BOUTIQUE_VVX24'">
        <div>
          La boutique de Noël VVX sera ouverte du 16 novembre au 15 décembre afin de vous permettre d'avoir vos produits
          sous le sapin. Vous aurez la possibilité de venir chercher vos produits gratuitement à L'Orée des Sources à
          Volvic (63530), ou de
          vous les faire livrer au point relais pickup de votre choix moyennant un coût.<br />
          Pour les personnes inscrites à la VVX 2024, un autre module verra le jour début 2024 afin de vous permettre de
          précommander les produits et de les récupérer pendant la VVX
        </div>
        <div class="mt-2"><u>Guide des tailles</u></div>
        <div>Cliquez sur le <v-btn density="compact" size="small" color="primary-dark" variant="elevated" elevation="0"
            icon="mdi-help"></v-btn> découvrir le guide des tailles précis de chaque article.</div>
        <div class="mt-2"><u>Service client</u></div>
        <div>Vous pouvez contacter le service client à l'adresse contact@volvic-vvx.com ou par téléphone au 04 73 97 16
          79.</div>
        <div class="mt-2"><u>Délais de livraison</u></div>
        <div>
          <ul>
            <li>Retrait à l'Orée des Sources à Volvic (63530): colis disponible maximum une semaine après la commande
            </li>
            <li>Expédition en point relais: 2 à 5 jours ouvrés après expédition</li>
          </ul>
        </div>
        <div><u>Frais de livraison</u></div>
        <div>Le retrait à L'Orée des Sources à Volvic (63530) est gratuit. Dans le cas d'une livraison en point relais
          Pickup, les frais d'expédition sont de 6€ pour les plus petits colis et de 7€ pour les plus gros.</div>
      </div>
      <div v-if="mainStore.module.base == 'BOUTIQUE_VVX25'">
        <div>
          La boutique de Noël VVX sera ouverte du 02 décembre au 15 décembre afin de vous permettre d'avoir vos produits
          sous le sapin. Vous aurez la possibilité de venir chercher vos produits gratuitement au 5 rue des Sources
          63530
          Volvic, ou de
          vous les faire livrer au point relais pickup de votre choix moyennant un coût.<br />

        </div>
        <div class="mt-2"><u>Guide des tailles</u></div>
        <div>Cliquez sur le <v-btn density="compact" size="small" color="primary-dark" variant="elevated" elevation="0"
            icon="mdi-help"></v-btn> découvrir le guide des tailles précis de chaque article.</div>
        <div class="mt-2"><u>Service client</u></div>
        <div>Vous pouvez contacter le service client à l'adresse contact@volvic-vvx.com ou par téléphone au 04 73 97 16
          79.</div>
        <div class="mt-2"><u>Délais de livraison</u></div>
        <div>
          <ul>
            <li>Retrait au 5 rue des Sources 63530 Volvic: colis disponible maximum une semaine après la commande</li>
            <li>Expédition en point relais: 2 à 5 jours ouvrés après expédition</li>
          </ul>
        </div>
        <div><u>Frais de livraison</u></div>
        <div>Le retrait au 5 rue des Sources 63530 Volvic est gratuit. Dans le cas d'une livraison en point relais
          Pickup, les frais d'expédition sont de 4,5€ (6,95€ si colis de plus d'un kilo).</div>

      </div>


      <div v-html="mainStore.module.metadatas.message_accueil"></div>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import MessageAccueilVOLVIC50_SOIREE from "@/components/App/Hooks/VOLVIC50/MessageAccueilSoiree.vue";
import MessageAccueilVOLVIC50 from "@/components/App/Hooks/VOLVIC50/MessageAccueilJournee.vue";
export default {
  components: {
    MessageAccueilVOLVIC50_SOIREE,
    MessageAccueilVOLVIC50
  },
  computed: {
    ...mapStores(useMainStore),
  },
};
</script>

<style lang="scss" scoped></style>